import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor, client } from '../../client';
import './Education.scss';
const Educations = () => {
  const [educations, setEducation] = useState([]);
  
  useEffect(() => {
    const query = '*[_type == "education"]';
  
    client.fetch(query).then((data) => {
      setEducation(data);
    });
    
  });

  return (
    <>
      <h2 className="head-text"><span>Education</span></h2>

      <div className="app__edu-container ">
        
        <div className="app__edu-exp">
          {educations.map((education) => (
            <motion.div
              className="app__edu-exp-item"
              key={education.year}
            >
              <div className="app__edu-exp-year">
                <p className="bold-text">{education.year}</p>
              </div>
              <motion.div className="app__edu-exp-works">
                {education.degree.map((degree) => (
                  <>
                    <motion.div
                      whileInView={{ opacity: [0, 1] }}
                      transition={{ duration: 0.5 }}
                      className="app__edu-exp-work"
                      data-tip
                      data-for={degree.name}
                      key={degree.name}
                    >
                      <h4 className="bold-text">{degree.name}</h4>
                      <p className="p-text">{degree.company}</p>
                    </motion.div>
                    <ReactTooltip
                      id={degree.name}
                      effect="solid"
                      arrowColor="#fff"
                      className="edu-tooltip"
                    >
                      {degree.desc}
                    </ReactTooltip>
                  </>
                ))}
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </>
  );
                };
  export default AppWrap(
    MotionWrap(Educations, 'app__works'),
    'education',
    'app__primarybg',
  )

